export { data_173 } from './173';
export { data_C62 } from './C62';

export function getDataByDomain(suffix = null) {
  // 方案1：如果传入了 suffix 参数，优先使用传入的值
  if (suffix && ['173', 'C62'].includes(suffix)) {
    const dataMap = {
      '173': require('./173').data_173,
      'C62': require('./C62').data_C62
    };
    return dataMap[suffix];
  }
  
  // 方案2：否则从域名获取后缀
  const hostname = window.location.hostname;
  const dataKeys = ['173', 'C62'];
  let matchedKey ; // 默认值
  
  for (const key of dataKeys) {
    if (hostname.includes(key)) {
      matchedKey = key;
      break;
    }
  }
  
  const dataMap = {
    '173': require('./173').data_173,
    'C62': require('./C62').data_C62
  };
  
  return dataMap[matchedKey] || dataMap['173'];
}

